import React from "react";
import { bool, func, oneOf, string } from "prop-types";
import { LoaderRing } from "..";
import "./button.ui.scss";

/**
 * @component
 * @param {object} props
 * @param {func} props.onClick
 * @param {string} props.className
 * @param {string} props.text
 * @param {boolean} props.isLoading
 * @param {boolean} props.disabled
 * @param {"orange"| "bordered-orange" | "azure" | "bordered-azure"} props.type
 */

export const Button = (props) => {
	const { onClick, className, text, type = "orange", isLoading, disabled } = props;
	return (
		<button className={`button button_${type} ${className}`} onClick={onClick} disabled={isLoading || disabled}>
			{isLoading ? <LoaderRing /> : text}
		</button>
	);
};

Button.propTypes = {
	onClick: func,
	className: string,
	text: string,
	type: oneOf(["orange", "bordered-orange", "azure", "bordered-azure"]),
	isLoading: bool,
	disabled: bool,
};
